export { default as Typewriter } from './components/typewriter/Typewriter';
export { CursorType } from './types/cursor';
export { TypewriterDelay, TypewriterSpeed } from './types/speed';
